/** CSK Dashboard constants — single source of truth for tab structure, brand, and config. */

import { GENERATOR_CODES, type GeneratorCode } from "@csk/core";
import constantsData from "./data/constants.data.json";

// ── Brand tokens ────────────────────────────────────────────

export const BRAND = constantsData.brand;
type BrandPalette = typeof BRAND;
type BrandColor = BrandPalette[keyof BrandPalette];

const GENERATOR_COLOR_BY_CODE = {
  G1: BRAND.amber,
  G2: BRAND.teal,
  G3: BRAND.violet,
  G4: BRAND.rose,
} as const satisfies Record<GeneratorCode, BrandColor>;

export const GENERATOR_COLORS: Record<GeneratorCode, BrandColor> =
  Object.fromEntries(
    GENERATOR_CODES.map((code) => [code, GENERATOR_COLOR_BY_CODE[code]]),
  ) as Record<GeneratorCode, BrandColor>;

// ── Tab registry ────────────────────────────────────────────

export interface TabDef {
  id: string;
  label: string;
}
export interface TabGroup {
  label: string;
  color: BrandColor;
  tabs: TabDef[];
}

export const TAB_GROUPS: TabGroup[] = constantsData.tabGroups.map((group) => ({
  label: group.label,
  color: BRAND[group.color as keyof BrandPalette],
  tabs: group.tabs,
}));

export const ALL_TABS = TAB_GROUPS.flatMap((g) => g.tabs);

// ── Metrics (from manifest) ─────────────────────────────────

export const METRICS = {
  ...constantsData.metrics,
  dashboardTabs: ALL_TABS.length,
} as const;
